<template>
  <div class="apollo-example">
    <!-- Apollo watched Graphql query -->
    <ApolloQuery v-on="$listeners" :query="gqlQuery">
      <template slot-scope="{ result: { loading, error, data }, isLoading }">
        <!-- Loading -->

        <!-- Error -->
        <h4 v-if="error" class="text-danger apollo text-center">
          <feather-icon class="mx-1" size="20" icon="AlertOctagonIcon" />
          حدث خطأ أثناء معالجة البيانات
        </h4>

        <!-- Result -->
        <div
          v-else-if="data && data[Object.keys(data)[0]].data.length > 0"
          class="result apollo"
        >
        <p v-for="item in mapGqlRes([{
    'id': '5' ,
    'name_ar': 'نقطة وصل',
    'bankAccounts': [
        {
            'id': '197',
            'branch_name': 'دمشق- 29 أيار',
            'accountManagers': [
        {
            'id': '1',
            'full_name': 'نشمستيا',
            '__typename': 'AccountManager'
        }
       ],
            '__typename': 'BankAccount'
        }
    ],
    '__typename': 'Ngo'
}
])">
          <hr />
        </p>
          <div>
            <b-table-lite
              id="gql-report"
              bordered
              striped
              :fields="fields"
              :items="mapGqlRes(data[Object.keys(data)[0]].data)"
              empty-text="لا يوجد سجلات لعرضها"
            >
              <template #head()="data">
                <span class="text-dark">{{ mapColumnName(data.column) }}</span>
              </template>
              <template #cell()="{ value }">
                <span class="text-dark">{{
                  value === true ? "نعم" : value === false ? "لا" : value
                }}</span>
              </template>
            </b-table-lite>
          </div>
          <!-- Pagination -->

          <div class="my-1">
            <b-row>
              <b-col
                lg="5"
                sm="12"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                عدد المدخلات في الصفحة
                <b-form-select
                  style="width: 50%"
                  v-model="pageSize"
                  :options="sizeOptions"
                  class="mx-1"
                />
              </b-col>
              <b-col
                lg="7"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="pageNumber"
                  :total-rows="data[Object.keys(data)[0]].paginatorInfo.total"
                  :per-page="size"
                  first-number
                  last-number
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mb-0"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </div>

        <h4 v-else-if="isLoading" class="text-dark apollo text-center">
          <feather-icon class="mx-1" size="20" icon="LoaderIcon" />
          جارٍ التحميل ...
        </h4>
        <h4 v-else class="text-secondary apollo text-center">
          <feather-icon class="mx-1" size="20" icon="AlertTriangleIcon" />
          لا توجد نتائج لعرضها
        </h4>
      </template>
    </ApolloQuery>
  </div>
</template>

<script>
import gql from "graphql-tag";

import {
  BTableLite,
  BFormSelect,
  BPagination,
  BRow,
  BCol,
} from "bootstrap-vue";
import { mapGetters, mapMutations } from "vuex";
import get from "lodash.get";
export default {
  components: {
    BTableLite,
    BFormSelect,
    BPagination,
    BRow,
    BCol,
  },
  props: {
    query: String,
    fields: Array,
  },

  apollo: {},

  computed: {
    ...mapGetters("AdvancedReports", ["size", "sizeOptions", "page"]),
    pageSize: {
      get() {
        return this.size;
      },
      set(val) {
        this.setSize(val);
      },
    },
    pageNumber: {
      get() {
        return this.page;
      },
      set(val) {
        this.setPage(val);
      },
    },

    gqlQuery() {
      const { query } = this;

      return gql`
        ${query}
      `;
    },
  },

  methods: {
    ...mapMutations("AdvancedReports", ["setSize", "setPage"]),

    mapColumnName(name) {
      // console.log("name" , name)
      // console.log("assf" , name
      //   .split(".")
      //   .map((el) => this.$t(el))
      //   .reverse()
      //   .map((el, index) => (index !== 0 ? `(${el})` : el))
      //   .join(" "))
      //   console.log("sdfsf" , name.replace(/\./g, '[0].'))
      return name
        .split(".")
        .map((el) => this.$t(el))
        .reverse()
        .map((el, index) => (index !== 0 ? `(${el})` : el))
        .join(" ");
    },
    res(res) {
      res = res.flatMap((mainObj, i) => {
          var newElements = [];

          // Loop over the object keys

          for (const key in mainObj) {
            if (Object.hasOwnProperty.call(mainObj, key)) {
              const element = mainObj[key];

              // if the key is array calculate the clones and return them to the flatMap

              if (Array.isArray(element)) {
                if (element.length === 0) return mainObj;
                console.log("element" , element)
                element.forEach((innerEl) => {
                  console.log("innerEl" , innerEl , typeof(innerEl))
                  if(typeof(innerEl) === 'object')
                  for (const el in innerEl) {
                    if (Array.isArray(innerEl[el])){
                      if(innerEl[el].length === 1)
                        innerEl[el] = innerEl[el][0]
                    }
                  }
                  const newElementToPush = { ...mainObj };
                  delete newElementToPush[key];
                  newElementToPush[key] = innerEl;
                  newElements.push(newElementToPush);
                });
                return newElements;
              }
            }
          }

          // else return the same element
          return mainObj;
          
        });
        return res
    },
    mapGqlRes(items) {
      if (!items || items.length === 0) return [];
      // This Function is for making cartasian Product of arrays in gql query result
      // First count how many times the functuin should run by counting the number of arrays in the result
      var repeats = 0;
      this.fields.forEach((el) => {
        if (
          Array.isArray(get(items[0], el.key.slice(0, el.key.lastIndexOf("."))))
        )
          repeats++;
      });
    console.log("repeats" , repeats)
      var res = [...items];

      while (repeats--) {
        console.log("start in repeats" , repeats-- , res )
        // Use Array.flatMap to replace array element with its clones  then flaten the array
        res = res.flatMap((mainObj, i) => {
          var newElements = [];

          // Loop over the object keys

          for (const key in mainObj) {
            if (Object.hasOwnProperty.call(mainObj, key)) {
              const element = mainObj[key];

              // if the key is array calculate the clones and return them to the flatMap

              if (Array.isArray(element)) {
                if (element.length === 0) return mainObj;
                console.log("element" , element)
                element.forEach((innerEl) => {
                  console.log("innerEl" , innerEl , typeof(innerEl))
                  if(typeof(innerEl) === 'object')
                  for (const el in innerEl) {
                    if (Array.isArray(innerEl[el])){
                      if(innerEl[el].length === 1)
                        innerEl[el] = innerEl[el][0]
                      // else
                      //   {
                      //   // Handle case where length > 1
                      //   innerEl[el].forEach((nestedItem) => {
                      //     const newObj = { ...mainObj };
                      //     newObj[key] = { ...innerEl, [el]: nestedItem };
                      //     newElements.push(newObj);
                      //   });
                      //   return;
                      // }
                      
                    }
                  }
                  const newElementToPush = { ...mainObj };
                  delete newElementToPush[key];
                  newElementToPush[key] = innerEl;
                  newElements.push(newElementToPush);
                });
                return newElements;
              }
            }
          }

          // else return the same element
          return mainObj;
          
        });
      }
      console.log("res" , res)
      return res;
    },
  }
};
</script>

<style scoped>
.form,
.input,
.apollo,
.message {
  padding: 12px;
}

label {
  display: block;
  margin-bottom: 6px;
}

.input {
  font-family: inherit;
  font-size: inherit;
  border: solid 2px #ccc;
  border-radius: 3px;
}

.error {
  color: red;
}

.images {
  display: grid;
  grid-template-columns: repeat(auto-fill, 300px);
  grid-auto-rows: 300px;
  grid-gap: 10px;
}

.image-item {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ccc;
  border-radius: 8px;
}

.image {
  max-width: 100%;
  max-height: 100%;
}

.image-input {
  margin: 20px;
}
</style>